'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * attribut disable (et non ng-disabled) pour desactiver les champs année et mois
 */
ngModule.directive("tlFieldYearAndMonth", function () {
  return {
    restrict: 'E',
    require: "ngModel",
    replace: true,
    scope: {},
    template: require("./tl-field-year-and-month.html"),
    link: function link($scope, $el, $attrs, ngModelCtrl) {
      var duration = $scope.duration = {
        years: null,
        months: null
      };
      $scope.refreshInputValues = function () {
        ngModelCtrl.$render();
      };

      // observe
      $attrs.$observe("disabled", function (disabled) {
        $scope.disabled = disabled == 'true' || disabled == true;
      });
      ngModelCtrl.$render = function () {
        var valueInMonths = ngModelCtrl.$viewValue;
        if (valueInMonths != null) {
          duration.years = Math.floor(valueInMonths / 12);
          duration.months = valueInMonths % 12;
        } else {
          duration.years = null;
          duration.months = null;
        }
      };
      var onDurationChange = function onDurationChange() {
        var valueInMonths = 12 * (duration.years || 0) + (duration.months || 0);
        ngModelCtrl.$setViewValue(valueInMonths || null); // yes, 0 -> null.
      };
      $scope.$watch("duration.years", onDurationChange);
      $scope.$watch("duration.months", onDurationChange);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/inputs/tl-field-year-and-month.js
// module id = 2972
// module chunks = 13